<div class="alert alert-danger alert-dismissible" *ngIf="errorMessage !== ''" role="alert">
  {{errorMessage}}<mat-icon (click)="closeAlert()" style="float:right;cursor:pointer;">close</mat-icon>
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="default" type="ball-spin-clockwise">
  <p style="color:white">{{spinnerMessage}}</p>
</ngx-spinner>

<h2 mat-dialog-title>Edit Upload Status</h2>

<mat-dialog-content>
  <p><strong>Upload Type:</strong> {{data.upload_type}}</p>

  <mat-form-field style="width:100%">
    <mat-label>Status</mat-label>
    <mat-select [(ngModel)]="eStatus" name="eStatus">
      <mat-option *ngFor="let s of STATUS_OPTIONS" [value]="s">{{s}}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field style="width:100%">
    <mat-label>Remarks</mat-label>
    <textarea matInput [(ngModel)]="eRemarks" name="eRemarks" rows="3"></textarea>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-button (click)="save()">Save</button>
</mat-dialog-actions>
